import Styles from './Fingering.module.css';

const KEY_LABELS = {
  j: '1', k: '2', l: '3', ';': '4', // trumpet, euphonium, tuba
  q: '1', w: '2', e: '3', c: 'T',   // french horn (T = trigger)
};
// trombone keys are already the position numbers '1'-'7'

const toLabels = (keys) => {
  if (!keys) return [];
  if (keys.length === 0) return ['0']; // open
  return [...new Set(keys.map((k) => KEY_LABELS[k] ?? k))].sort();
};

const Fingering = ({ keys }) => {
  const labels = toLabels(keys);

  return (
    <div className={Styles.slot} aria-live="polite">
      {labels.length > 0 && (
        <div className={Styles.card}>
          {labels.map((l) => (
            <span key={l} className={Styles.num}>
              {l}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default Fingering;